var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view',{staticClass:"child-view"}):_vm._e()],1),(!_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e(),(_vm.isLogin)?_c('Login'):_vm._e(),(_vm.$store.state.isFull)?_c('clear-record'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }